const ErrorMessage = (props) => {
		return (
			<div className='uauth-item-label-error'>
				<p>{props.error}</p>
			</div>
		)
}

export default ErrorMessage;